import React from "react";
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import AddNewTeam from '../../components/admincomponents/AddTeam';

function AddTeam({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <AddNewTeam />            
    </>
  );
}

export default AddTeam;
